import script from "./consortiumModal1.vue?vue&type=script&setup=true&lang=js"
export * from "./consortiumModal1.vue?vue&type=script&setup=true&lang=js"

import "./consortiumModal1.vue?vue&type=style&index=0&id=7705e11f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7705e11f"]])

export default __exports__